import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  generateEWayBill,
  cancelEWayBill,
  generateEInvoice,
  generateEInvoiceCredit,
  generateEInvoiceDebit,
  getInvoiceDetailForEInvoice,
  cancelEInvoice,
} from "./gst.async";

const initialState = {
  gstGenerateEWayBillLoader: false,
  gstGenerateEWayBillInfo: {},

  gstCancelEWayBillLoader: false,
  gstCancelEWayBillInfo: {},
  
  gstGenerateEInvoiceLoader: false,
  gstGenerateEInvoiceInfo: {},

  gstEInvoiceLoader: false,
  gstEInvoiceInfo: {},

  gstCancelEInvoiceLoader: false,
  gstCancelEInvoiceInfo: {},

};

export const gstSlice = createSlice({
  name: "gst",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(generateEWayBill.pending), (state) => {
      state.gstGenerateEWayBillLoader = true;
    });
    builder.addMatcher(isAnyOf(generateEWayBill.fulfilled), (state, action) => {
      state.gstGenerateEWayBillLoader = false;
      state.gstGenerateEWayBillInfo = action.payload;
    });
    builder.addMatcher(isAnyOf(generateEWayBill.rejected), (state, action) => {
      state.gstGenerateEWayBillLoader = false;
    });

    builder.addMatcher(isAnyOf(generateEInvoice.pending), (state) => {
      state.gstGenerateEInvoiceLoader = true;
    });
    builder.addMatcher(isAnyOf(generateEInvoice.fulfilled), (state, action) => {
      state.gstGenerateEInvoiceLoader = false;
      state.gstGenerateEInvoiceInfo = action.payload;
    });
    builder.addMatcher(isAnyOf(generateEInvoice.rejected), (state, action) => {
      state.gstGenerateEInvoiceLoader = false;
    });

    builder.addMatcher(isAnyOf(getInvoiceDetailForEInvoice.pending), (state) => {
      state.gstEInvoiceLoader = true;
    });
    builder.addMatcher(isAnyOf(getInvoiceDetailForEInvoice.fulfilled), (state, action) => {
      state.gstEInvoiceLoader = false;
      state.gstEInvoiceInfo = action.payload.data;
    });
    builder.addMatcher(isAnyOf(getInvoiceDetailForEInvoice.rejected), (state, action) => {
      state.gstEInvoiceLoader = false;
    });

    builder.addMatcher(isAnyOf(generateEInvoiceCredit.pending), (state) => {
      state.gstGenerateEInvoiceLoader = true;
    });
    builder.addMatcher(isAnyOf(generateEInvoiceCredit.fulfilled), (state, action) => {
      state.gstGenerateEInvoiceLoader = false;
      state.gstGenerateEInvoiceInfo = action.payload;
    });
    builder.addMatcher(isAnyOf(generateEInvoiceCredit.rejected), (state, action) => {
      state.gstGenerateEInvoiceLoader = false;
    });

    builder.addMatcher(isAnyOf(generateEInvoiceDebit.pending), (state) => {
      state.gstGenerateEInvoiceLoader = true;
    });
    builder.addMatcher(isAnyOf(generateEInvoiceDebit.fulfilled), (state, action) => {
      state.gstGenerateEInvoiceLoader = false;
      state.gstGenerateEInvoiceInfo = action.payload;
    });
    builder.addMatcher(isAnyOf(generateEInvoiceDebit.rejected), (state, action) => {
      state.gstGenerateEInvoiceLoader = false;
    });
  },
  reducers: {
    emptySales: () => initialState,
  },
});
export const { emptySales } = gstSlice.actions;

export default gstSlice.reducer;
